export const BALANCE_COLUMNS = [
  { key: 'opening_balance', label: 'reports.trial_balance.columns.opening_balance' },
  { key: 'debit', label: 'reports.trial_balance.columns.debit' },
  { key: 'credit', label: 'reports.trial_balance.columns.credit' },
  { key: 'closing_balance', label: 'reports.trial_balance.columns.closing_balance' },
] as const
